import { ZONES, zoneLabel } from "../lib/time";

// Liste fermée des fuseaux (la même que le serveur), en liste native : s'ouvre bien au doigt, sans panneau à part. `inheritLabel` ajoute le choix
// « celui de l'entreprise » (valeur vide) pour le profil d'une personne.
export default function TimezoneSelect({ id, value, onChange, disabled, inheritLabel, "data-testid": testid }) {
  return (
    <select id={id} value={value || ""} disabled={disabled} onChange={(e) => onChange(e.target.value || null)} data-testid={testid}
      className="h-10 w-full max-w-sm rounded-md border border-slate-200 bg-white px-3 text-sm text-slate-900 disabled:opacity-60">
      {inheritLabel && <option value="">{inheritLabel}</option>}
      {ZONES.map((zone) => <option key={zone} value={zone}>{zoneLabel(zone)}</option>)}
    </select>
  );
}
